import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "horizontal-summary-card" };
const _hoisted_2 = { class: "summary-header" };
const _hoisted_3 = { class: "summary-title" };
const _hoisted_4 = { class: "chart-area" };
const _hoisted_5 = { class: "bar-row" };
const _hoisted_6 = { class: "bar-track" };
const _hoisted_7 = { class: "bar-amount amount-income" };
const _hoisted_8 = { class: "bar-row" };
const _hoisted_9 = { class: "bar-track" };
const _hoisted_10 = { class: "bar-amount" };
const _hoisted_11 = { class: "breakdown" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "breakdown-left" };
const _hoisted_14 = { class: "breakdown-name" };
const _hoisted_15 = { class: "breakdown-right" };
const _hoisted_16 = ["src"];
import { computed, ref, onMounted, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HorizontalSpendingChart',
    props: {
        data: {}
    },
    emits: ["category-click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const animated = ref(false);
        function replayAnimation() {
            animated.value = false;
            requestAnimationFrame(() => {
                requestAnimationFrame(() => { animated.value = true; });
            });
        }
        onMounted(replayAnimation);
        watch(() => props.data, replayAnimation, { deep: true });
        const CATEGORY_ORDER = ['Income', 'Essentials', 'Lifestyle', 'Future', 'General'];
        function categoryRank(name) {
            const idx = CATEGORY_ORDER.indexOf(name);
            return idx === -1 ? CATEGORY_ORDER.length : idx;
        }
        const outItems = computed(() => (props.data?.breakdown ?? [])
            .filter(b => b.direction === 'out')
            .sort((a, b) => categoryRank(a.name) - categoryRank(b.name)));
        const sortedBreakdown = computed(() => {
            const items = props.data?.breakdown ?? [];
            return [...items].sort((a, b) => categoryRank(a.name) - categoryRank(b.name));
        });
        const maxAmount = computed(() => {
            const d = props.data;
            if (!d)
                return 0;
            return Math.max(d.totalIn, d.totalOut, 0);
        });
        const inBarWidth = computed(() => {
            if (!props.data || maxAmount.value === 0)
                return 0;
            return (props.data.totalIn / maxAmount.value) * 100;
        });
        const outBarWidth = computed(() => {
            if (!props.data || maxAmount.value === 0)
                return 0;
            return (props.data.totalOut / maxAmount.value) * 100;
        });
        function formatAmount(amount) {
            if (localStorage.getItem('randomiseFigures') === 'true')
                return '£####';
            return new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 2,
            }).format(amount);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.data?.rangeLabel), 1),
                    _createElementVNode("span", {
                        class: _normalizeClass(["summary-net", { 'summary-net-positive': (_ctx.data?.net ?? 0) > 0 }])
                    }, _toDisplayString(_ctx.data ? formatAmount(_ctx.data.net) : ''), 3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "bar-label" }, "In", -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", {
                                class: "bar bar-in",
                                style: _normalizeStyle({ width: (animated.value ? inBarWidth.value : 0) + '%' })
                            }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.data ? formatAmount(_ctx.data.totalIn) : ''), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "bar-label" }, "Out", -1)),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", {
                                class: "bar bar-out",
                                style: _normalizeStyle({ width: (animated.value ? outBarWidth.value : 0) + '%' })
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(outItems.value, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.name,
                                        class: "bar-segment",
                                        style: _normalizeStyle({ flex: String(item.amount), backgroundColor: item.colour })
                                    }, null, 4));
                                }), 128))
                            ], 4)
                        ]),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.data ? formatAmount(_ctx.data.totalOut) : ''), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedBreakdown.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: item.name,
                            class: "breakdown-row",
                            onClick: ($event) => (emit('category-click', item.name))
                        }, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", {
                                    class: "colour-dot",
                                    style: _normalizeStyle({ backgroundColor: item.colour })
                                }, null, 4),
                                _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["breakdown-amount", { 'amount-income': item.direction === 'in' }])
                                }, _toDisplayString(formatAmount(item.amount)), 3),
                                _createElementVNode("img", {
                                    class: "breakdown-arrow",
                                    src: require('@/assets/arrow-right.png'),
                                    alt: ""
                                }, null, 8, _hoisted_16)
                            ])
                        ], 8, _hoisted_12));
                    }), 128))
                ])
            ]));
        };
    }
});
